import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { List } from 'react-movable';
import { SportMarketTemplatesState } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.state';
import {
    SportMarketTemplatesList,
    SportMarketTemplatesListItem,
} from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { SportMarketTemplatesItem } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplatesItem';
import { MarketPopup } from 'src/components/SportPopup/SportMarketTemplates/Popup/Popup';

interface PropsType {
    sportId: string;
    label: string;
}

export const SportMarketTemplates = observer('SportMarketTemplates', ({ sportId }: PropsType) => {
    const appState = useAppStateContext();
    const [state] = useState(() => new SportMarketTemplatesState(sportId, appState.sdkStaff));

    if (state.marketTemplates === 'loading') {
        return <div className='market-templates-wrapper'>Loading market templates...</div>;
    }

    return (
        <div className='market-templates-wrapper'>
            <List
                onChange={state.onSort}
                values={state.marketTemplates}
                renderList={({ children, props }) => (
                    <SportMarketTemplatesList {...props}>{children}</SportMarketTemplatesList>
                )}
                renderItem={({ value: item, props, isDragged }) => {
                    const id = state.getTemplateKey(item);
                    return (
                        <SportMarketTemplatesListItem
                            key={id}
                            {...props}
                            isDragged={isDragged}
                            style={{
                                ...props.style,
                            }}
                            onClick={() => state.toggleTemplate(item)}
                            data-test={`market-templates-item-${id}`}
                        >
                            <SportMarketTemplatesItem
                                isDragged={isDragged}
                                templateId={id}
                                sportId={sportId}
                                marketTemplatesState={state}
                            />
                        </SportMarketTemplatesListItem>
                    );
                }}
            />

            {state.openedPopup === 'isMarketTemplateOpen' ? (
                <MarketPopup
                    onClose={state.togglePopup}
                    sportId={sportId}
                    templates={state.marketTemplates}
                />
            ) : null}

            <button
                type='button'
                className='btn btn-add'
                onClick={() => state.togglePopup('isMarketTemplateOpen')}
            >
                Add market template
            </button>
        </div>
    );
});
